import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryRetryDelay, shouldRetryQuery } from "@/lib/query-retry";

const DEFAULT_STALE_TIME_MS = 30 * 1000;

export const getRouter = () => {
  // Mặc định của react-query (staleTime 0, refetch khi focus tab, retry 3 với MỌI
  // lỗi) làm mỗi component dùng chung một khóa lại tự bắn request riêng, và mỗi lần
  // quay lại tab là cả loạt query gọi lại. Query nào cần tươi hơn thì tự đặt staleTime/interval;
  // số dư/quota đã được làm mới theo sự kiện (`refreshBoideUser`).
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME_MS,
        refetchOnWindowFocus: false,
        // Không thử lại khi server đã trả lỗi — xem `query-retry.ts`.
        retry: shouldRetryQuery,
        retryDelay: queryRetryDelay,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 30000,
  });

  return router;
};
